import.meta.glob(['@images/**', '!@images/assets/**']);
import.meta.env.DEV && import("@styles/main.sass");

import {createApp} from "petite-vue";
import {isInViewport} from "./utils/is-in-viewport";
import {initMap} from "./map";
import {initContactMap} from "./contact-map";
import initArchiveProgram from "./views/archive-program";

interface Header {
    opened: boolean

    handleOpenedHeader(state: boolean): void
}

(() => { // Hiding header
    const headerEl = document.querySelector<HTMLElement>('[data-header]'),
        headerScope: Header = {
            opened: false,
            handleOpenedHeader(state) {
                document.documentElement.classList.toggle("u-hiddenOverflow", state)
                hidingOnScroll()
            }
        }

    headerEl && createApp(headerScope).mount(headerEl)
    if (!headerEl) return

    let lastScroll = 0

    const hidingOnScroll = () => {
        const currentScroll = window.scrollY;

        if (currentScroll > 480) {
            headerEl.classList.add('is-sticked')
            headerEl.classList[currentScroll > lastScroll ? 'add' : 'remove']('is-up')
        } else {
            headerEl.classList.remove('is-sticked', 'is-up')
        }

        lastScroll = currentScroll;
    }

    hidingOnScroll();
    window.addEventListener('scroll', () => hidingOnScroll(), {passive: true});

    const megaNavigations = headerEl.querySelectorAll<HTMLElement>('.SubNavigation--mega')
    headerEl.querySelector('.HeaderInner').addEventListener('mouseenter', () => {
        megaNavigations.forEach(megaMenu => {
            const icon = megaMenu.previousElementSibling.querySelector('svg')
            if (!icon) return

            const iconPosition = icon.getBoundingClientRect()
            megaMenu.parentElement.style.setProperty(
                '--navigationSubmenuPositionOrigin',
                `${(iconPosition.left - Math.max((window.innerWidth - 1224) / 2, 0) + iconPosition.width / 2) / Math.min(1204, window.innerWidth) * 100}%`
            )
        })
    })

    headerEl.querySelectorAll('[data-submenu-toggle]')
        .forEach(toggle => toggle.addEventListener('click', e => {
            e.preventDefault()
            toggle.closest('li').classList.toggle('is-open')
        }))
})();

initArchiveProgram();
document.querySelector('[data-share-links]') && createApp().mount('[data-share-links]');

(() => {
    const animationDuration = 2400;
    const frameDuration = 1000 / 60;
    const totalFrames = Math.round(animationDuration / frameDuration);
    const easeOutQuad = (t) => t * (2 - t);

    const animateCountUp = (el) => {
        if (el.classList.contains("is-counted")) return;
        el.classList.add("is-counted");

        const main = el.querySelector('span[data-about-number]');
        const unit = el.querySelector('span[data-about-number] + span');

        const raw = main.textContent.replace(',', '.').replace(/[^\d.]/g, '');
        const countTo = parseFloat(raw);

        if (isNaN(countTo)) return;

        const hasDecimal = raw.includes('.');
        let frame = 0;

        const counter = setInterval(() => {
            frame++;
            const progress = easeOutQuad(frame / totalFrames);
            const currentCount = countTo * progress;

            main.textContent = currentCount.toLocaleString("cs-CZ", {
                minimumFractionDigits: hasDecimal ? 1 : 0,
                maximumFractionDigits: hasDecimal ? 1 : 0,
            });

            if (unit) {
                unit.textContent = unit.textContent;
            }

            if (frame === totalFrames) clearInterval(counter);
        }, frameDuration);
    };

    function isElementInViewport(el: HTMLElement) {
        const rect = el.getBoundingClientRect();

        return (
            rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && /* or $(window).height() */
            rect.right <= (window.innerWidth || document.documentElement.clientWidth) /* or $(window).width() */
        );
    }

    const runCountUp = () => {
        document.querySelectorAll('[data-about-number]').forEach((el: HTMLElement) => {
            isElementInViewport(el) && animateCountUp(el.closest('.CompanyNumbersItem-value'));
        });
    }

    runCountUp();
    window.addEventListener("scroll", runCountUp);
})();

declare global {
    interface Window {
        initMaps: () => void
        mapLoaded: boolean
        wpObject: {
            gMapsApi: string
            mapPosition: string
            mapAddressUrl: string
            mapIcon: string
            mapBackgroundColor: string
            mapPrimaryColor: string
        }
    }
}


(() => {
    window.mapLoaded = false

    const loadMapOnce = () => {
        const anyMapVisible =
            isInViewport(document.querySelector('[data-map-holder]'), 4) ||
            isInViewport(document.querySelector('[data-contact-map-holder]'), 4)

        if (window.mapLoaded || !anyMapVisible) return

        window.mapLoaded = true

        const gMapsJs = document.createElement('script')
        gMapsJs.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyA1rkdyQZQTjjN5KEkvJMqb2Oy5RQjvK-A&callback=initMaps&libraries=&v=weekly`
        document.body.insertAdjacentElement('beforeend', gMapsJs)
    }

    document.addEventListener("DOMContentLoaded", loadMapOnce)
    document.addEventListener("scroll", loadMapOnce)
})()

window.initMaps = () => {
    const mapHolder = document.querySelector('[data-map-holder]')
    const contactHolder = document.querySelector('[data-contact-map-holder]')

    if (mapHolder) initMap()
    if (contactHolder) initContactMap()
}


(() => {
    const checkboxes = document.querySelectorAll('input[name="kategorie"]');
    const icoField = document.getElementById('ico-field');
    const icoInput = icoField?.querySelector('input');

    function toggleCheckbox(e) {
        checkboxes.forEach(cb => {
            if (cb !== e.target) cb.checked = false;
        });

        if (e.target.id === 'pravnik-checkbox' && e.target.checked) {
            icoField.classList.add('is-active');
            icoInput.required = true;
        } else {
            icoField.classList.remove('is-active');
            icoInput.required = false;
            icoInput.value = '';
        }
    }

    checkboxes.forEach(cb => cb.addEventListener('change', toggleCheckbox));

    const selected = [...checkboxes].find(cb => cb.checked && cb.id === 'pravnik-checkbox');
    if (selected) {
        icoField.classList.add('is-active');
        icoInput.required = true;
    }
})();

(() => {
    const initProgramSticky = () => {
        const sticky = document.querySelector<HTMLElement>('[data-program-sticky]')
        const paramsInner = document.querySelector<HTMLElement>('.SingleHero-parametersInner')
        if (!sticky || !paramsInner) return

        const root = document.documentElement
        root.classList.add('has-program-sticky')

        const setSpace = (active: boolean) => {
            const h = sticky.offsetHeight || 0
            root.style.setProperty('--program-sticky-space', active ? `${h + 16}px` : `0px`)
        }

        const show = () => {
            sticky.classList.add('is-active')
            sticky.setAttribute('aria-hidden', 'false')
            setSpace(true)
        }

        const hide = () => {
            sticky.classList.remove('is-active')
            sticky.setAttribute('aria-hidden', 'true')
            setSpace(false)
        }

        const getBottomY = () => {
            const top = paramsInner.getBoundingClientRect().top + window.scrollY
            return top + paramsInner.offsetHeight
        }

        let bottomY = 0
        const recalc = () => {
            bottomY = getBottomY()
        }

        let ticking = false
        const update = () => {
            const y = window.scrollY
            const triggerLine = y + (window.innerHeight * 0.99)

            if (bottomY <= triggerLine) show()
            else hide()
        }

        const onScroll = () => {
            if (ticking) return
            ticking = true
            requestAnimationFrame(() => {
                update()
                ticking = false
            })
        }

        hide()
        recalc()
        update()

        window.addEventListener('scroll', onScroll, { passive: true })
        window.addEventListener('resize', () => {
            recalc()
            update()
        })
    }

    initProgramSticky()
})()
